import React, { FC } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import Connected from './Connected';
import NoAccess from './NoAccess';
import { Image, Section } from './styled';

interface Props {
  connected: boolean;
}

const Header: FC<Props> = ({ connected }) => {
  const query = useStaticQuery(graphql`
    query LoungeHeroImage {
      file(relativePath: { eq: "lounge-hero.png" }) {
        childImageSharp {
          gatsbyImageData(width: 740)
        }
      }
    }
  `);

  return (
    <Section>
      <Image
        image={query.file.childImageSharp.gatsbyImageData}
        alt="Lounge Hero"
        $isConnected={connected}
      />
      {connected ? <Connected /> : <NoAccess />}
    </Section>
  );
};

export default Header;
